import { useSelector } from "react-redux";
import { getDesignDataForSelectedDesignArea } from '@configuratorware/configurator-frontendgui/App/Reducers/DesignArea/Selectors';
import get from 'lodash/get';
import { makeStyles } from "@material-ui/core/styles";
import React from 'react';

const useStyles = makeStyles({
  disabled: {
    '& button': {
      pointerEvents: "none",
      backgroundColor: '#DDDDDD',
      '& *': {
        color: 'rgba(0, 0, 0, 0.26)',
      },
    },
  },
});

export const FreePositionCheck = ({ children }) => {
  const isFreePosition = useSelector(state => {
    const designData = getDesignDataForSelectedDesignArea(state);
    const objectCount = get(designData, 'canvasData.objects.length', 0);
    return objectCount < 3;
  });
  const classes = useStyles();
  return <div className={isFreePosition ? '' : classes.disabled}>
    {children}
  </div>;
}

export default FreePositionCheck;
